import MessageFormat from 'messageformat'

export const generateTranslations = formatter => {
  return {
    configurationsAmount: {
      ru: formatter.compile(`{count} {count, plural, one {конфигурация} few {конфигурации} other {конфигураций}}`),
      en: formatter.compile(`{count} {count, plural, one {configuration} few {configurations} other {configurations}}`)
    },
    dayAmount: {
      ru: formatter.compile(`{count} {count, plural, one {день} few {дня} other {дней}}`),
      en: formatter.compile(`{count} {count, plural, one {day} few {days} other {days}}`)
    },
    monthAmount: {
      ru: formatter.compile(`{count} {count, plural, one {месяц} few {месяца} other {месяцев}}`),
      en: formatter.compile(`{count} {count, plural, one {month} few {month} other {month}}`)
    },
    coresAmount: {
      ru: formatter.compile(`{count} {count, plural, one {ядро} few {ядра} other {ядер}}`),
      en: formatter.compile(`{count} {count, plural, one {core} few {cores} other {cores}}`)
    }
  }
}

export const translations = generateTranslations(new MessageFormat('ru'))